import { useQuery } from '@tanstack/react-query';
import Option from '../models/Option';
import Price from '../models/Price';

export default function useOption(optionId, schoolId) {
  return useQuery(['option', optionId], () => (
    Option
      .includes(['image_types', 'prices'])
      .merge({ prices: Price.where({ for_school: schoolId }) })
      .find(optionId)
      .then((res) => res.data)
  ), { enabled: !!(optionId && schoolId) });
}
